export default __webpack_public_path__ + "static/media/H4005.19dcb4fe.mp3";